import axios from "axios";
import { API_POINT_DOMAIN } from "../constants/urls";

//** Base Url API
const apiFetech = axios.create({
  baseURL: API_POINT_DOMAIN
});
// // ** Set Header Lang
apiFetech.interceptors.request.use(
  async function (config) {
    // Do something before request is sent
    let language = "ar";
    if (localStorage.getItem("lang")) {
      language = localStorage.getItem("lang") || "ar";
    }
    config.headers.common["X-localization"] = language;
    // Set City ID
    const cityObjString =
             await localStorage.getItem("clientCity") || `{id:0}`;
            const cityObj = JSON.parse(cityObjString);
            if(!config.url.includes("search/city_id")){

              if (config.url.includes("?")) {
                if (!config.url.includes("city_id")) {
                  config.url = `${config.url}&city_id=${cityObj?.id}`;
                }
              } else {
                if (!config.url.includes("city_id")) {
                  config.url = `${config.url}?city_id=${cityObj?.id}`;
                }
              }
            }
            
            if (config.url.includes("providers?") || config.url.includes("search/city_id")) {
              
            }else{
              config.headers["city_id"] = cityObj.id;
            }
    // End Set City ID
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

export default apiFetech;
